import { createAPI } from '@common'

export default {
  //获取租户使用情况表
  getTenantUsage: config => createAPI('customEncryptApiName-1/0nfejby.tubu0ufobou0tubujtujd0hmpcbm0tubujtujd', 'post', config),
  //获取全量日期使用列表
  getAllUsage: config => createAPI('customEncryptApiName-1/0nfejby.tubu0ufobou0tubujtujd0tupsbhfVtfe0tubujtujd', 'post', config),
  //导出租户统计表
  exportTenantUsage: config => createAPI('customEncryptApiName-1/0nfejby.tubu0ufobou0tubujtujd0fyqpsu0tubujtujd01', 'post', config),
  //导出全量统计表
  exportTotalUsage: config => createAPI('customEncryptApiName-1/0nfejby.tubu0ufobou0tubujtujd0fyqpsu0tubujtujd02', 'post', config),
}
